// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host .form-group-title {
  font-weight: bold;
  margin-top: 30px;
}
:host a {
  font-size: 14px;
}
:host .communication-method-icon {
  margin-left: 5px;
  margin-right: 5px;
}`, "",{"version":3,"sources":["webpack://./src/app/U2000_sharedmodules/U2000_security/U2000_verifyidentity/U2000_choosecommunication/U2000_choosecommunication-form/U2000_choosecommunication-form.component.scss"],"names":[],"mappings":"AAKI;EACI,iBAAA;EACA,gBAAA;AAJR;AAMI;EACI,eAAA;AAJR;AAOI;EACI,gBAAA;EACA,iBAAA;AALR","sourcesContent":["\n@import \"../../../../../U2000_style/U2000_style-mixins\";\n@import \"../../../../../U2000_style/U2000_style-variables\";\n\n:host {\n    .form-group-title {\n        font-weight: bold;\n        margin-top: 30px;\n    }\n    a {\n        font-size: 14px;\n    }\n\n    .communication-method-icon {\n        margin-left: 5px;\n        margin-right: 5px;\n    }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
